import { render } from "./BlViewRichChoice.vue?vue&type=template&id=703f9a44"
import script from "./BlViewRichChoice.vue?vue&type=script&lang=js"
export * from "./BlViewRichChoice.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/b7562a83-daa0-4796-bff7-c3f4922e39c8/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__